import React from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';

/**
 *
 */
export default class UserMessageActions extends React.Component {
	/**
	 *
	 * @param props
	 */
	constructor(props) {
		super(props);

		this.options = [
			{ type: 'view', icon: 'eye2', label: 'label.view' },
			{ type: 'unread', icon: 'eye-off', label: 'label.unread' }
		];

		this.onClick = this.onClick.bind(this);
	}

	/**
	 *
	 * @return {*}
	 */
	render() {
		const rows = this.options.map((option, index) => {
			if (this.props.hideTypes.indexOf(option.type) >= 0) {
				return null;
			}

			return (
				<div
					key={`ia-${index}`}
					className="actions__action"
					data-type={option.type}
					onClick={this.onClick}>
					<i className={`icon icon--${option.icon}-black`} />
					<FormattedMessage id={option.label} />
				</div>
			);
		});

		return <div className="user-message-actions actions">{rows}</div>;
	}

	/**
	 *
	 * @param e
	 */
	onClick(e) {
		e.preventDefault();
		const action = e.currentTarget.dataset.type;
		this.props.onSelect(action);
	}
}

UserMessageActions.propTypes = {
	onSelect: PropTypes.func.isRequired,
	hideTypes: PropTypes.array
};

UserMessageActions.defaultProps = {
	hideTypes: []
};
